import * as firebase from './firebase';
import * as auth from './auth';

export default {
  firebase,
  auth
};



// WEBPACK FOOTER //
// ./src/api/index.js